module.exports = __webpack_public_path__ + "img/jardin8.b1646a3d.jpg";